export default class ScheduledReportService {
    constructor($http, appConfig) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
    }
  
    listScheduledReports(entityId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/scheduledreports/list/${entityId}`);
    }

    add(scheduledReport) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/scheduledreports/add`, scheduledReport);
    }    

    delete(entityId, schedledReportId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/scheduledreports/delete/${entityId}/${schedledReportId}`);
    }    

    get(entityId, schedledReportId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/scheduledreports/get/${entityId}/${schedledReportId}`);
    }   
    
    edit(scheduledReportId, scheduledReport) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/scheduledreports/edit/${scheduledReportId}`, scheduledReport);
    }       
  }
  


// WEBPACK FOOTER //
// ./client/app/components/admin/scheduledReportsManagement/scheduledReport.service.js